import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { SharedDataService } from 'orv-ui-base-lib';

import { AuthService } from './../auth/auth.service';

@Injectable()
export class AclService {

	userFeatures: string[];
	userDepos: string[];
	userRoles: string[];

	constructor(
		private authService: AuthService,
		private sharedDataService: SharedDataService
	) {
		this.sharedDataService.currentFeatures.subscribe(features => {
			this.userFeatures = features;
		});

		this.sharedDataService.currentRoles.subscribe(roles => {
			this.userRoles = roles;
		});

		this.sharedDataService.currentDepos.subscribe(depos => {
			this.userDepos = depos;
		});
	}

	getDepots() {
		const token = this.authService.getToken();
		const dToken = jwtDecode(token);
		const depo = !dToken.depo ? [] : JSON.parse(dToken.depo);
		return depo ? depo.sort((a: string, b: string) => a.localeCompare(b)) : depo;
	}

	hasPermission(aclFeatures: string | string[], and: boolean = true, not: boolean = false): boolean {
		if (!aclFeatures) return true;
		else if (!this.userFeatures) return false;
		const features = this.toArray(aclFeatures);
		return and ?
			features.every(feature => (this.checkFeature(this.userFeatures, feature, not))) :
			features.some(feature => (this.checkFeature(this.userFeatures, feature, not)));
	}

	hasPermissionInSection(section: string): boolean {
		if (!section) {
			return true;
		} else if (!this.userFeatures) {
			return false;
		} else {
			return this.userFeatures.indexOf('section.' + section) >= 0;
		}
	}

	hasRole(role: string): boolean {
		return this.userRoles.indexOf(role) >= 0;
	}

	private toArray(value: string | string[]): string[] {
		return typeof value === 'string' ? [value] : value;
	}

	private checkFeature(userFeatures: string[], feature: string, not: boolean) {
		return not ? userFeatures.indexOf(feature) < 0 : userFeatures.indexOf(feature) >= 0;
	}

}
